// extracted by mini-css-extract-plugin
export default {"container":"QG-z","header":"RG-z","details":"SG-z","link":"TG-z"};